import * as React from 'react'
import useSWR from 'swr'
import { useParams } from 'react-router-dom'
import { addDays, format } from 'date-fns'
import { getTheoreticalVertrekken } from '../data/travelinfo-trip.api'
import { ServerTimeContext } from '../contexts/serverTime.context'
import { filterPassagesAfterDate } from '../utils/date.utils'

const THEORETICAL_PREFIX = 'theoretical-'

export async function fetchTheoreticalPassagesForADate(
  stops: string[],
  date: Date,
) {
  const isoFormattedDate = format(date, 'yyyy-MM-dd')
  return getTheoreticalVertrekken({
    haltenummers: stops,
    exploitationDate: isoFormattedDate,
  })
}

async function fetchTheoreticalPassages(key: string) {
  const stops = key.split(THEORETICAL_PREFIX)[1].split('+')

  const today = new Date()
  const tomorrow = addDays(new Date(), 1)

  const todaysPassages = await fetchTheoreticalPassagesForADate(stops, today)
  const nextDaysPassages = await fetchTheoreticalPassagesForADate(
    stops,
    tomorrow,
  )
  return todaysPassages.concat(nextDaysPassages)
}

export function useTheoreticalPassages() {
  const { haltenummers } = useParams()
  const { getCalibratedDateTime } = React.useContext(ServerTimeContext)
  const { data, isLoading, error } = useSWR(
    THEORETICAL_PREFIX + haltenummers,
    fetchTheoreticalPassages,
    {
      fallbackData: [],
      revalidateOnFocus: false,
      revalidateOnMount: true,
    },
  )

  if (error) {
    return {
      data: filterPassagesAfterDate(data, getCalibratedDateTime()),
      error,
      isLoading,
    }
  }

  return {
    data: filterPassagesAfterDate(data, getCalibratedDateTime()),
    isLoading,
    error,
  }
}
